import styled from '@emotion/styled';
import CaretV2Icon from '../../SvgIcons/CaretV2';
import { MEDIA_QUERY, COLORS, FONT, SPACING } from '../../../styles/emotion';
import {
  fieldHeight,
  fieldHeightMobile,
  inputBaseStyles,
  disabledStyles,
  FormLabel,
} from '../form.styles';

export const StyledCaret = styled(CaretV2Icon)<{ disabled?: boolean }>`
  position: absolute;
  top: ${fieldHeight / 2 - 16 / 2}px;
  ${MEDIA_QUERY.MOBILE} {
    top: ${fieldHeightMobile / 2 - 16 / 2}px;
  }
  right: 13px;
  transform: rotate(90deg);
  transition: all 0.2s ease;
  color: ${COLORS.BLUE};
  ${({ disabled }) => disabled && `color: ${COLORS.ALTO};`}
`;

export const InputSection = styled.div`
  cursor: pointer;
  position: relative;
`;

export const Input = styled.input<{ error?: boolean; isPlaceholder?: boolean }>`
  ${({ error }) => inputBaseStyles(error ? 'error' : '')};
  display: flex;
  justify-content: space-between;
  padding-right: 32px;
  cursor: pointer;
  caret-color: transparent;
  &:disabled {
    ${disabledStyles};
    & ${StyledCaret} {
      color: ${COLORS.PRIVILEGE};
    }
  }
  ${({ isPlaceholder }) => isPlaceholder && `color: ${COLORS.ALTO}`};

  &:focus {
    outline: none;
  }
  height: ${fieldHeight}px;
  ${MEDIA_QUERY.MOBILE} {
    pointer-events: none;
    height: ${fieldHeightMobile}px;
  }
`;

export const Trigger = styled.div<{ disabled?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  ${({ disabled }) => disabled && `color: ${COLORS.ALTO}`};
`;

export const DropdownSection = styled.div<{
  position: string;
}>`
  ${({ position }) => `position: ${position};`}
`;

export const DropdownListHeader = styled.div`
  border-bottom: 1px solid ${COLORS.ALTO};
  padding: ${SPACING.MD};
  position: relative;
`;

export const DropdownEmptyState = styled.div`
  padding: ${SPACING.MD};
  position: relative;
`;

export const DropdownFieldContainer = styled.div<{
  inline?: boolean;
  alignment: 'vertical' | 'horizontal';
  hasLabel: boolean;
  hasMinWidth: boolean;
}>`
  color: ${COLORS.EMPEROR};
  font-size: ${FONT.FONT_SIZE_SMALL};
  ${({ hasMinWidth }) => hasMinWidth && `min-width: 150px;`}
  ${({ inline }) => inline && `display: inline-block;`}

  ${({ alignment, hasLabel }) =>
    alignment === 'horizontal'
      ? `display: flex;
      ${FormLabel} {
        line-height: ${fieldHeight}px;
        ${MEDIA_QUERY.MOBILE} {
          line-height: ${fieldHeightMobile}px;
        }
      }
      ${DropdownSection} {
        ${hasLabel ? 'margin-left: 8px;' : ''}
      }`
      : `${DropdownSection} {
        ${hasLabel ? 'margin-top: 4px;' : ''}
      }`}
`;
